// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mismatch[data-v-581dcad3]{display:inline-block;width:50%;white-space:normal}.error[data-v-581dcad3]{color:#e22828;font-weight:600}", ""]);
// Exports
module.exports = exports;
